import React from "react";

import HomeHeader from "./HomeHeader";

import ServicesSection from "./ServicesSection";
import ProcessSection from "./ProcessSection";
import ProSection from "./ProSection";
import ContactSection from "./ContactSection";
import HomeFooter from "./HomeFooter";

const Welcome = () => {
  return (
    <div className="min-h-screen bg-white">

      <HomeHeader />
      <ServicesSection />
      <ProcessSection />
      <ProSection />
      <ContactSection />
      <HomeFooter />
    </div>
  );
};

export default Welcome;